import React, { type ComponentType } from 'react';
import { lazy } from 'react-loosely-lazy';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries';
import Placeholder from '@atlassian/jira-placeholder';
import { useShortcuts } from '../controllers';

export { ActionDropdownItem } from './dropdown';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const ShortcutsDialogLazy = lazy<ComponentType>(
	() => import(/* webpackChunkName: "atlassian-jira-shortcuts-dialog" */ './main'),
	{ ssr: false },
);

const ShortcutsDialog = () => {
	const [{ isShortcutsDialogVisible }] = useShortcuts();

	return isShortcutsDialogVisible ? (
		<JSErrorBoundary id="shortcuts-dialog" packageName="jira-shortcuts-dialog" fallback="unmount">
			<Placeholder name="atlassian-jira-shortcuts-dialog" fallback={null}>
				<ShortcutsDialogLazy />
			</Placeholder>
		</JSErrorBoundary>
	) : null;
};

export default ShortcutsDialog;
